import { render, staticRenderFns } from "./PromotionSubsetBadgesCode.vue?vue&type=template&id=5896e650&"
import script from "./PromotionSubsetBadgesCode.vue?vue&type=script&lang=ts&"
export * from "./PromotionSubsetBadgesCode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports